import { Button } from "@mui/material";

const ButtonAddyPurple = function ({
    height = "15px",
    width = "15px",
    text = "Placeholder",
    icon = "",
    iconHeight = "15px",
    iconWidth = "15px",
    onClickFunction = () => {},
    disabled = false,
    textColor = "white",
    className = "",
    children = <></>,
}) {
    return (
        <Button
            disabled={disabled}
            className={`h-[${height}] w-[${width}]` + " " + className}
            startIcon={
                icon !== "" ? (
                    <img
                        src={icon}
                        className="contrast-[1000%]"
                        height={iconHeight}
                        width={iconWidth}
                    />
                ) : (
                    <></>
                )
            }
            onClick={onClickFunction}
            variant="contained"
            sx={{
                textTransform: "none",
                color: textColor,
                fontSize: "14",
                background: "var(--primary-color)",
                borderRadius: "8px",
                boxShadow: "none !important",
                "&:active": { background: "var(--primary-color)" },
                "&:visited": { background: "var(--primary-color)" },
                "&:hover": {
                    background: "var(--primary-color)",
                    boxShadow: "none !important",
                },
                "&:focus": { background: "var(--primary-color)",
                    boxShadow: "none !important",
                },
                height: height,
                width: width,
            }}
        >
            {text !== "Placeholder" ? text : children}
        </Button>
    );
};

export { ButtonAddyPurple };
